<template>
  <!-- Normal Search -->
  <div class="grid bg-white" v-if="!advanceSearch">
    <div class="row grid-body">
      <div class="col-md-2">
        <select
          class="form-control search-type"
          v-model="serverParams.searchType"
        >
          <option
            v-for="searchType in searchTypes"
            :value="searchType.column"
            :key="searchType.column"
          >
            {{ searchType.title }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <select class="form-control" v-model="serverParams.option">
          <option v-for="opt in options" :key="opt.value" :value="opt.value">
            {{ opt.name }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <v-select
          taggable
          multiple
          v-model="serverParams.keywords"
          pushTags
          :closeOnSelect="false"
          :options="[]"
        />
      </div>
      <div class="col-md-3">
        <button class="btn btn-success" @click="$emit('submit', true)">
          <i class="fa fa-search" aria-hidden="true"></i> Search
        </button>
        <button
          class="btn btn-primary"
          @click="$emit('update:advanceSearch', true)"
        >
          Advance Search
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
        </button>
      </div>
      <div class="col-md-2">
        <toggle-button
          v-model="serverParams.productionOnly"
          @change="$emit('toggle', true)"
        /><br />
        <span class="text-bold" v-if="serverParams.productionOnly"
          >Production Shirts Only</span
        >
        <span class="text-bold" v-else>All Shirts</span>
      </div>
    </div>
  </div>
  <!-- Normal Search -->
</template>

<script>
export default {
  props: ["advanceSearch", "searchTypes", "options", "serverParams"],
};
</script>
